import { render, staticRenderFns } from "./CompetitionObservationsTextarea.vue?vue&type=template&id=692627ab&"
import script from "./CompetitionObservationsTextarea.vue?vue&type=script&lang=js&"
export * from "./CompetitionObservationsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports